// Detect IOS. to add Class 'IOS' on html.
(function() {
  if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' IOS');
  }
})();



//////////////////
// WEBPACK FOOTER
// ./src/app/utilities/detect-ios.js
// module id = 1345
// module chunks = 22